import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-white/60">
        <span className="overline">Verifying session…</span>
      </div>
    );
  }
  // Phase 1c — preserve the intended admin URL (e.g. the email deep-link
  // /admin/fulfillment/{public_id}) so AdminLogin can bounce back after
  // authentication.
  if (user === false) {
    const nextPath = `${loc.pathname}${loc.search || ""}`;
    return <Navigate to={`/admin/login?next=${encodeURIComponent(nextPath)}`} replace />;
  }
  return children;
}
